import { Button, Select, Switch } from "@rio-cloud/rio-uikit";

export type TSelect = {
  id: string;
  label: string;
  type?: string;
};

interface Props {
  active: boolean;
  toogle: (i: boolean) => void;
  fuel: TSelect;
  onChangeFuel?: (item: TSelect) => void;
  vision: TSelect;
  onChangeVision?: (item: TSelect) => void;
  fuelLevel: number;
  onChangeFuelLevel: (level: number) => void;
  capacity: number;
  onChangeCapacity: (capacity: number) => void;
  consume: number;
  onChangeConsume: (consume: number) => void;
  onSubmit: () => void;
}

export const FuelOptions = [
  {
    id: "1",
    label: "Diesel",
    type: "Litros",
  },
  {
    id: "2",
    label: "Etanol",
    type: "Litros",
  },
  {
    id: "3",
    label: "Elétrico",
    type: "kWh",
  },
  {
    id: "4",
    label: "Gasolina",
    type: "Litros",
  },
  {
    id: "5",
    label: "Hidrogênio",
    type: "Litros",
  },
  {
    id: "6",
    label: "GNV",
    type: "M³",
  },
];

export const VisionOptions = [
  {
    id: "1",
    label: "Ida e volta",
  },
  {
    id: "2",
    label: "Somente ida",
  },
  {
    id: "3",
    label: "Somente volta",
  },
];

const Autonomy = ({
  toogle,
  active,
  fuel,
  onChangeFuel,
  fuelLevel,
  onChangeFuelLevel,
  vision,
  onChangeVision,
  capacity,
  onChangeCapacity,
  consume,
  onChangeConsume,
  onSubmit,
}: Props) => {
  return (
    <div className="display-flex flex-column gap-10">
      <div>
        <Switch onChange={toogle} checked={active}>
          <span>Exibir autonomia no mapa</span>
        </Switch>
      </div>
      <div>
        <div className="display-flex gap-5 padding-y-10">
          <span className="rioglyph rioglyph-info-sign margin-top-3 text-color-info"></span>
          <span className="text-normal text-size-14">
            As paradas são geradas automaticamente, considerando o tanque cheio após cada abastecimento. Se, no dia da viagem, os níveis de combustível estiverem muito diferentes do previsto, as sugestões de
            abastecimento podem não ser mais adequadas.
          </span>
        </div>
      </div>
      <div>
        <div className="display-flex gap-10">
          <div className="form-group padding-x-0 width-100pct">
            <label>Combustivel</label>
            <Select
              placeholder=""
              options={FuelOptions}
              value={[fuel.id ?? "1"]}
              onChange={(select) => onChangeFuel?.(select as TSelect)}
              disabled={!active}
            />
          </div>
          <div className="form-group padding-x-0 width-200">
            <label>Tipo</label>
            <input className="form-control" type="text" disabled value={fuel.type} defaultValue={fuel.type} />
          </div>
          <div className="form-group padding-x-0 width-100pct">
            <label>Nível de combustível({fuel.type})</label>
            <div className="input-group">
              <input
                className="form-control"
                type="number"
                value={fuelLevel}
                onChange={(e) => onChangeFuelLevel(parseFloat(e.target.value))}
                disabled={!active}
              />
              <span className="input-group-addon">{fuel.type}</span>
            </div>
          </div>
        </div>
        <div className="display-flex gap-10">
          <div className="form-group padding-x-0 width-100pct">
            <label>Capacidade do tanque</label>
            <div className="input-group">
              <input
                className="form-control"
                type="number"
                value={capacity}
                onChange={(e) => onChangeCapacity(parseFloat(e.target.value))}
                disabled={!active}
              />
              <span className="input-group-addon">{fuel.type}</span>
            </div>
          </div>
          <div className="form-group padding-x-0 width-100pct">
            <label>Média de consumo</label>
            <div className="input-group">
              <input
                className="form-control"
                type="number"
                value={consume}
                onChange={(e) => onChangeConsume(parseFloat(e.target.value))}
                disabled={!active}
              />
              <span className="input-group-addon">{fuel.type === "Litros" ? "Km/L" : fuel.type}</span>
            </div>
          </div>
        </div>
        <div className="width-100pct margin-top-15">
          <Button className="height-19 width-100pct" disabled={!active} onClick={onSubmit}>
            Sugerir paradas para abastecimento
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Autonomy;
